import react from "react";
import classNames from "classnames";

const classNameActive =
  "border-gray-300 bg-white hover:bg-gray-50 text-gray-500 duration-300 cursor-pointer";
const classNameDisabled =
  "border-gray-300 opacity-30 text-gray-500 cursor-not-allowed";

const PrevPage = ({ canPreviousPage, ...rest }) => {
  return (
    <button
      {...rest}
      disabled={!canPreviousPage}
      className={classNames(
        " relative inline-flex items-center px-2 py-2 rounded-l-md border text-sm font-medium",
        {
          [classNameActive]: canPreviousPage,
          [classNameDisabled]: !canPreviousPage,
        }
      )}
    >
      <span className="sr-only">Previous</span>
      <svg
        className="h-5 w-5"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
        fill="currentColor"
        aria-hidden="true"
      >
        <path
          fillRule="evenodd"
          d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
          clipRule="evenodd"
        />
      </svg>
    </button>
  );
};

export default PrevPage;
